import { FastForward } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import  FaSearch from "@react-icons/all-files/fa/FaSearch";
const SearchBar = ({
  searchTerm,
  setSearchTerm,
  selectedModule,
  setSelectedModule,
  resultFound,
  setIsSearch,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [localSearchTerm, setLocalSearchTerm] = useState(" ");
  const navigate = useNavigate(); // set rout global search

  const modules = [
    "All Modules",
    "Orders",
    "Products",
    "Collections",
    "Purchase Orders",
    "Customers",
  ];

  // Toggle the dropdown visibility
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Set selected module and close dropdown
  const handleModuleSelect = (module) => {
    setSelectedModule(module);
    setIsDropdownOpen(false);
  };

  // Handle local search term change
  const handleLocalSearchChange = (e) => {
    setLocalSearchTerm(e.target.value);
  };

  // Handle search button click
  const handleSearchClick = async () => {
    setSearchTerm(localSearchTerm);
    setIsSearch(true);
    setLocalSearchTerm(" ");
    await new Promise((resolve) => setTimeout(resolve, 1000));

    if (resultFound) {
      navigate("/admin/global-search");
      console.log("Search result found");
    } else {
      alert("No result found for this search");
      console.log("No result found for this search");
      // setIsSearch(resultFound);
    }
  };
  return (
    <div style={{ padding: "10px", maxWidth: "800px", margin: "auto" }}>
      <div
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          border: "1px solid #ccc",
          borderRadius: "5px",
        }}
      >
        {/* Dropdown Button */}
        <div style={{ position: "relative" }}>
          <button
            onClick={toggleDropdown}
            style={{
              backgroundColor: "#EFF6FF",
              border: "none",
              cursor: "pointer",
              fontSize: "16px",
              padding: "8px",
              borderRight: "2px solid gray",
              width: "150px",
              borderTopLeftRadius: "5px",
              borderBottomLeftRadius: "5px",
            }}
            className="flex"
          >
            <div
              style={{
                width: "135px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              {selectedModule}
            </div>
            <span>&#128899;</span>
          </button>
          {isDropdownOpen && (
            <ul
              style={{
                position: "absolute",
                top: "100%",
                left: "0",
                background: "white",
                border: "1px solid #ccc",
                borderRadius: "5px",
                listStyle: "none",
                margin: 0,
                padding: "7px",
                width: "150px",
                zIndex: 10,
              }}
            >
              {modules.map((module) => (
                <li
                  key={module}
                  onClick={() => handleModuleSelect(module)}
                  style={{
                    padding: "5px",
                    cursor: "pointer",
                    background: selectedModule === module ? "#f0f0f0" : "white",
                  }}
                >
                  {module}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Search Input */}
        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
          <input
            type="text"
            value={localSearchTerm}
            onChange={handleLocalSearchChange}
            placeholder="Search"
            style={{
              border: "none",
              outline: "none",
              flex: 1,
              fontSize: "16px",
              marginLeft: "10px",
            }}
          />
          <button onClick={handleSearchClick} className="search-button mr-4">
            <FaSearch />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
